import { render } from "./PreExpedicao.vue?vue&type=template&id=19d9b9ac&scoped=true"
import script from "./PreExpedicao.vue?vue&type=script&lang=js"
export * from "./PreExpedicao.vue?vue&type=script&lang=js"

import "./PreExpedicao.vue?vue&type=style&index=0&id=19d9b9ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d9b9ac"]])

export default __exports__